// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import type { ReactNode } from 'react'
import Box from '@mui/material/Box'

/** D-UI-3 c5 — a section's title, one line of context, and its actions on the right. */
export default function PageHeader({ title, subtitle, actions, icon }: { title: ReactNode; subtitle?: ReactNode; actions?: ReactNode; icon?: ReactNode }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, mb: 1.5, flexWrap: 'wrap' }}>
      <Box>
        <Box component="h2" sx={{ m: 0, fontSize: 15, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>{icon}{title}</Box>
        {subtitle && <Box sx={{ mt: 0.25, fontSize: 12.5, color: 'text.secondary' }}>{subtitle}</Box>}
      </Box>
      {actions && <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>{actions}</Box>}
    </Box>
  )
}
